import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { FerryMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: FerryMapItem;
  hoverData?: FerryMapItem;
};

type HoverProps = {
  hoverData: FerryMapItem;
  clickData?: FerryMapItem;
};

export const FerryPopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("ferry-page");

  const data = clickData ?? hoverData;

  if (!data) return null;

  const { name, description, maintainerOrganization } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={name[0]}
      title={name}
      subheader={description ?? ""}
      content={
        <>
          {maintainerOrganization ? (
            <Typography variant="body2" align="left" noWrap>
              {`${t("maintainer-organization")}: ${
                maintainerOrganization.name
              }`}
            </Typography>
          ) : null}
        </>
      }
    />
  );
};
